import {CheckIcon, Combobox, ComboboxOptionProps, Group} from '@mantine/core';
import {memo, ReactNode} from 'react';
import {PrimaryColorCssVar} from '../../../styles/default-theme.tsx';

type ComboboxOption = ComboboxOptionProps & {
  label: string;
  render?: ReactNode;
  rightSection?: ReactNode | undefined;
};
export const ComboboxOption = memo<ComboboxOption>(
  ({value, label, active, render, rightSection, ...rest}) => {
    return (
      <Combobox.Option value={value} active={active} {...rest}>
        {render ? (
          render
        ) : (
          <Group justify='space-between'>
            <Group gap='sm'>
              {active ? (
                <CheckIcon size={12} color={PrimaryColorCssVar} />
              ) : null}
              <span>{label}</span>
            </Group>
            {rightSection}
          </Group>
        )}
      </Combobox.Option>
    );
  },
);